module.exports = __webpack_public_path__ + "static/img/banner7.0cb13a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner7.png
// module id = 4xfl
// module chunks = 0